import { IStyleFunctionOrObject, ITooltipHostStyleProps, ITooltipHostStyles, TooltipHost } from '@fluentui/react';
import { FC, ReactNode } from 'react';

interface IProps {
    children?: ReactNode;
    text: string | number,
    style?: React.CSSProperties
    tooltipStyles?: IStyleFunctionOrObject<ITooltipHostStyleProps, ITooltipHostStyles>,
}

export const TooltipWrapper: FC<IProps> = ({ text, style = {}, tooltipStyles, children }) => (
    <TooltipHost style={{ alignContent: 'center', ...style }} styles={tooltipStyles} content={`${text}`}>
        {children || text}
    </TooltipHost>
);